import React, { useEffect, useState } from "react";
import { CategoriesStyled } from "./CategoriesStyled";
import { useAppDispatch } from "../../store/store";
import { getCurrentLanguageId } from "../../lang/utils";
import { fetchCategories } from "./slice/actions";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getCategoriesData, getCategoriesIsLoading } from "./slice/selectors";
import Box from "../../UI/Box";
import {
  CategoriesPropsInterface,
  CategoryInterface,
} from "../../entities/Category";
import CategoriesSkeleton from "./CategoriesSkeleton";
import { SORTING_TYPE } from "../../entities/Filter";
import { sortByDirection } from "../../utils/sortByDirection";
import Filter from "../Filter/Filter";
import SkeletonComponent from "../SkeletonComponent";
import { TEST_ID } from "../../shared/testid";

const Categories: React.FC<CategoriesPropsInterface> = ({
  activeCategoryId,
  setActiveCategory,
}: CategoriesPropsInterface) => {
  const [sort, setSort] = useState<SORTING_TYPE>(SORTING_TYPE.ASC);
  const [sortedCategories, setSortedCategories] = useState<CategoryInterface[]>(
    [],
  );
  const dispatch = useAppDispatch();
  const languageId = getCurrentLanguageId();
  const { parentId } = useParams<{ parentId: string }>();
  const { categories = [] } = useSelector(getCategoriesData);
  const isLoading = useSelector(getCategoriesIsLoading);

  useEffect(() => {
    dispatch(
      fetchCategories({
        params: {
          parentId,
          hideParent: true,
          id: parentId,
          limit: 100,
        },
      }),
    );
  }, [dispatch, languageId, parentId]);

  useEffect(() => {
    const savedCategoryId = localStorage.getItem('activeCategoryId');
    if (savedCategoryId) {
      const savedCategory = categories.find(category => category.id === parseInt(savedCategoryId, 10));
      if (savedCategory) {
        setActiveCategory(savedCategory);
      }
    }
  }, [categories, setActiveCategory]);

  useEffect(() => {
    if (sortedCategories.length) {
      const savedCategoryId = localStorage.getItem('activeCategoryId');
      // TODO: quick fix, to be written in redux
      const activeCategory = savedCategoryId 
        ? sortedCategories.find(category => category.id === parseInt(savedCategoryId, 10)) 
        : sortedCategories[0];
      if (activeCategory) {
        setActiveCategory(activeCategory);
        localStorage.setItem('activeCategoryId', activeCategory.id.toString());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortedCategories]);

  useEffect(() => {
    if (categories.length) {
      const sortedByDirectionCategories = sortByDirection(
        [...categories],
        sort,
      );
      setSortedCategories(sortedByDirectionCategories);
    }
  }, [categories, sort]);

  const handleCategoryClick = (item: CategoryInterface) => {
    setActiveCategory(item);
    localStorage.setItem('activeCategoryId', item.id.toString());
    localStorage.setItem('activeCategoryParentId', parentId || '');
  };

  return (
    <CategoriesStyled>
      <Box>
        <Filter sort={sort} setSort={setSort} />
        <SkeletonComponent
          isLoading={isLoading}
          skeleton={<CategoriesSkeleton />}
        >
          <ul className="categories-list">
            {sortedCategories.map((item) => (
              <li
                className={activeCategoryId === item.id ? "active" : ""}
                key={item.id}
                onClick={() => handleCategoryClick(item)}
                data-testid={`${TEST_ID.SUBCATEGORY.SUBCATEGORY_ITEM}-${item.id}`}
              >
                {item.name}
              </li>
            ))}
          </ul>
        </SkeletonComponent>
      </Box>
    </CategoriesStyled>
  );
};

export default Categories;